<template>
  <v-container
      fill-height
      fluid
      pa-0
      style="background-image: radial-gradient(farthest-corner at 50% 50%, #004678 20%, #042345 100%); user-select: none;"
  >
    <v-row align="center" class="fill-height white--text" justify="center" no-gutters>
      <v-col cols="12">
        <v-row justify="center" align="center" class="fill-height">
          <v-col cols="12">
            <div class="text-center">
              <div class="display-2">Welcome to your TDC Toolkit</div>
              <div class="title mt-4">Please authenticate to continue</div>
            </div>
          </v-col>
          <v-col cols="auto">
            <v-card class="rounded-lg" :min-width="500">
              <v-card-title>
                <div class="text-center" style="width: 100%;">Sign In</div>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-text-field
                    hint="Please enter a password to continue"
                    label="Password"
                    class="rounded-lg"
                    outlined
                    color="#042345"
                    :append-icon="!visibilityState ? 'mdi-eye-off' : 'mdi-eye'"
                    :error-messages="errorMessages"
                    :rules="rules"
                    :type="visibilityState ? 'text' : 'password'"
                    v-model="password"
                    @keyup.enter="login()"
                    @click:append="setVisibilityState()"
                    @input="errorMessages = []"
                ></v-text-field>
              </v-card-text>
              <v-card-actions class="pt-0 px-4 pb-4">
                <v-spacer></v-spacer>
                <v-btn text
                       class="rounded-lg"
                       :loading="loading"
                       :disabled="password.length < 3"
                       @click="login()"
                >Sign In
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import auth from '@/assets/text/auth.json'

export default {
  name: "Auth",
  data: () => ({
    password: '',
    errorMessages: [],
    rules: [(val) => !!val || 'This field is required.'],
    visibilityState: false,
    loading: false
  }),
  methods: {
    setVisibilityState() {
      this.visibilityState = !this.visibilityState;
    },
    login() {
      this.loading = true;
      if (this.password === auth.password) {
        this.$store.dispatch('setAuthTrue').then(
            () => {
              this.$router.push('/app-select');
              this.loading = false;
            }
        );
      } else {
        this.$store.dispatch('setAuthFalse').then(
            () => {
              this.errorMessages.push('Incorrect password, please try again');
              this.loading = false;
            }
        );
      }
    }
  }
}
</script>

<style scoped>

</style>